// // app/layout.tsx
// "use client";
// import React, { useState, ReactNode } from 'react';
// import Link from 'next/link';
// import { usePathname } from 'next/navigation';
// import * as Global from '@utils/global';
// import './layout.css';
// import './globals.css';
// import { AuthProvider, useAuth } from '@/utils/authcontext';

// type Props = {
//   children: ReactNode;
// };

// function LayoutContent({ children }: Props) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const pathname = usePathname();
//   const { domainTitle, employeeGUID, employeeFlag, employeeName } = useAuth();
//   const isEmployee = employeeFlag === "1";

//   // 必要ならログイン画面でメニュー非表示にできる
//   // const isMenuHide = pathname === "/signon";
//   const isMenuHide = false;

//   function displayDomainTitle(domaintitle: string) {
//     if (domaintitle == "") {
//       return Global.systemTitle
//     }
//     const isProduction =
//       typeof window !== "undefined" &&
//       window.location.hostname === "oknetse.kmgr.jp";
//     return domaintitle + (isProduction ? "" : " DEVELOP");
//   }

//   return (
//     <div className="layout">
//       {!isMenuHide && (
//         <>
//           <button className="hamburger" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>☰</button>
//           <nav className="sidebar">
//             <ul>
//               <li><Link href="/"><i className="fas fa-home menuicon-awesome" />ホーム</Link></li>
//               {employeeGUID ? (
//                 <>
//                   {/* {isEmployee && (
//                     <>
//                       <li><Link href="/topics"><i className="far fa-comment-dots menuicon-awesome" />トピックス</Link></li>
//                       <li><Link href="/dakoku"><i className="far fa-comment-dots menuicon-awesome" />マイ打刻</Link></li>
//                       <li><Link href="/mynote"><i className="far fa-comment-dots menuicon-awesome" />マイノート</Link></li>
//                       <li><Link href="/recording"><i className="far fa-comment-dots menuicon-awesome" />音声記録庫</Link></li>
//                       <li><Link href="/kojinsiwake"><i className="far fa-comment-dots menuicon-awesome" />メール通知</Link></li>
//                       <li><Link href="/profile"><i className="far fa-comment-dots menuicon-awesome" />マイデータ</Link></li>
//                     </>
//                   )} */}
//                   <li><Link href="/assistant"><i className="far fa-comment-dots menuicon-awesome" />アシスタント</Link></li>
//                   <li><Link href="/signout"><i className="fa-solid fa-user-minus menuicon-awesome" />ログアウト</Link></li>
//                 </>
//               ) : (
//                 <li><Link href="/signon"><i className="fa-solid fa-user-plus menuicon-awesome" />ログイン</Link></li>
//               )}
//               <li><Link href="/privacy"><i className="fa-solid fa-circle-info menuicon-awesome" />ポリシー</Link></li>
//             </ul>
//           </nav>

//           {isMobileMenuOpen && (
//               <div className="overlay" onClick={() => setIsMobileMenuOpen(false)}></div>
//           )}

//           {/* サイドバー（スマホ用） */}
//           {isMobileMenuOpen && (
//               <div className="mobile-sidebar">
//                 <ul>
//                   <li><Link href="/" onClick={() => setIsMobileMenuOpen(false)}><i className="fas fa-home menuicon-awesome" />ホーム</Link></li>
//                   {employeeGUID ? (
//                     <>
//                       {/* {isEmployee && (
//                         <>
//                           <li><Link href="/topics" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />トピックス</Link></li>
//                           <li><Link href="/dakoku" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />マイ打刻</Link></li>
//                           <li><Link href="/mynote" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />マイノート</Link></li>
//                           <li><Link href="/recording" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />音声記録庫</Link></li>
//                           <li><Link href="/kojinsiwake" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />メール通知</Link></li>
//                           <li><Link href="/profile" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />マイデータ</Link></li>
//                         </>
//                       )} */}
//                         <li><Link href="/assistant" onClick={() => setIsMobileMenuOpen(false)}><i className="far fa-comment-dots menuicon-awesome" />アシスタント</Link></li>
//                         <li><Link href="/signout" onClick={() => setIsMobileMenuOpen(false)}><i className="fa-solid fa-user-minus menuicon-awesome" />ログアウト</Link></li>
//                     </>
//                   ) : (
//                     <li><Link href="/signon" onClick={() => setIsMobileMenuOpen(false)}><i className="fa-solid fa-user-plus menuicon-awesome" />ログイン</Link></li>
//                   )}
//                   <li><Link href="/privacy" onClick={() => setIsMobileMenuOpen(false)}><i className="fa-solid fa-circle-info menuicon-awesome" />ポリシー</Link></li>
//                 </ul>
//               </div>
//           )}

//         </>
//       )}
//       {/* <div className="main-content">{children}</div> */}

//       {/* ここを置き換える */}
//       <div className="main-content">
//         <div className="page-header">
//           <Link href="/" className="page-header-link">
//             <div style={{ color:"black", display: "flex", alignItems: "center", gap: "2px" }}>
//               <img src="/oknetse32.png" width={24} height={24} alt="App Logo" />
//               <span>
//                 {displayDomainTitle(domainTitle ?? "")}
//                 {employeeName ? `(${employeeName})` : ""}
//               </span>
//             </div>
//           </Link>
//         </div>
//         <div className="page-body">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function RootLayout({ children }: Props) {
//   return (
//     <html lang="ja">
//       <head>
//         {/* <title>{Global.systemTitle}</title> */}
//         <title>{displayDomainTitle(domainTitle ?? "")}</title>
//         {/* VIEWPORT指定によるズーム抑制は以下を入れても機能せず。いったんコメントとする。 */}
//         {/* <meta name="viewport"
//               content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" /> */}
//         <link
//           rel="stylesheet"
//           // href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css"
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </head>
//       <body>
//         <AuthProvider>
//           <LayoutContent>{children}</LayoutContent>
//         </AuthProvider>
//       </body>
//     </html>
//   );
// }

// app/layout.tsx
"use client";

import React, { useState, ReactNode, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import * as Global from "@utils/global";
import "./layout.css";
import "./globals.css";
import { AuthProvider, useAuth } from "@/utils/authcontext";

/* =========================
   共通関数（外に出す）
   ========================= */
function displayDomainTitle(domaintitle: string) {
  if (!domaintitle) {
    return Global.systemTitle;
  }
  // const isProduction =
  //   typeof window !== "undefined" &&
  //   window.location.hostname === "oknetse.kmgr.jp";
  // return domaintitle + (isProduction ? "" : " DEVELOP");
  return domaintitle;
}

type Props = {
  children: ReactNode;
};

/* =========================
   内部レイアウト
   ========================= */
function LayoutContent({ children }: Props) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const pathname = usePathname();
  const { domainTitle, employeeGUID, employeeFlag, employeeName } = useAuth();

  const isEmployee = employeeFlag === "1";
  const isMenuHide = false;

  /* =========================
     title を動的に更新
     ========================= */
  useEffect(() => {
    const title = displayDomainTitle(domainTitle ?? "");
    document.title = title;
  }, [domainTitle]);

  return (
    <div className="layout">
      {!isMenuHide && (
        <>
          <button
            className="hamburger"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            ☰
          </button>

          {/* ===== サイドバー（PC） ===== */}
          <nav className="sidebar">
            <ul>
              <li>
                <Link href="/">
                  <i className="fas fa-home menuicon-awesome" />
                  ホーム
                </Link>
              </li>

              {employeeGUID ? (
                <>
                  <li>
                    <Link href="/assistant">
                      <i className="far fa-comment-dots menuicon-awesome" />
                      アシスタント
                    </Link>
                  </li>
                  <li>
                    <Link href="/signout">
                      <i className="fa-solid fa-user-minus menuicon-awesome" />
                      ログアウト
                    </Link>
                  </li>
                </>
              ) : (
                <li>
                  <Link href="/signon">
                    <i className="fa-solid fa-user-plus menuicon-awesome" />
                    ログイン
                  </Link>
                </li>
              )}

              <li>
                <Link href="/privacy">
                  <i className="fa-solid fa-circle-info menuicon-awesome" />
                  ポリシー
                </Link>
              </li>
            </ul>
          </nav>

          {isMobileMenuOpen && (
            <div
              className="overlay"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}

          {/* ===== サイドバー（モバイル） ===== */}
          {isMobileMenuOpen && (
            <div className="mobile-sidebar">
              <ul>
                <li>
                  <Link
                    href="/"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="fas fa-home menuicon-awesome" />
                    ホーム
                  </Link>
                </li>

                {employeeGUID ? (
                  <>
                    <li>
                      <Link
                        href="/assistant"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        <i className="far fa-comment-dots menuicon-awesome" />
                        アシスタント
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/signout"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        <i className="fa-solid fa-user-minus menuicon-awesome" />
                        ログアウト
                      </Link>
                    </li>
                  </>
                ) : (
                  <li>
                    <Link
                      href="/signon"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      <i className="fa-solid fa-user-plus menuicon-awesome" />
                      ログイン
                    </Link>
                  </li>
                )}

                <li>
                  <Link
                    href="/privacy"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="fa-solid fa-circle-info menuicon-awesome" />
                    ポリシー
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </>
      )}

      {/* ===== メインコンテンツ ===== */}
      <div className="main-content">
        <div className="page-header">
          <Link href="/" className="page-header-link">
            <div
              style={{
                color: "black",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                src="/oknetse32.png"
                width={24}
                height={24}
                alt="App Logo"
              />
              <span>
                {displayDomainTitle(domainTitle ?? "")}
                {employeeName ? ` (${employeeName})` : ""}
              </span>
            </div>
          </Link>
        </div>

        <div className="page-body">{children}</div>
      </div>
    </div>
  );
}

/* =========================
   RootLayout（最外）
   ========================= */
export default function RootLayout({ children }: Props) {
  return (
    <html lang="ja">
      <head>
        {/* 初期タイトル（後で LayoutContent が上書き） */}
        <title>{Global.systemTitle}</title>

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
      </head>
      <body>
        <AuthProvider>
          <LayoutContent>{children}</LayoutContent>
        </AuthProvider>
      </body>
    </html>
  );
}
